module.exports = __webpack_public_path__ + "img/温州市教育局.f401ea07.png";